const ChatService = {
  setMessage: async (id, type, message) => {
    const { data } = await ovpFetch(`/chat/${id}/pin-message`, {
      method: 'POST',
      iLikeItRaw: true,
      body: JSON.stringify({
        message,
        type,
      }),
    });
    return data;
  },
  /**
   * List users in chat
   * @param {*} id
   * @returns {Array}
   */
  listUsers: async (id) => {
    const { data } = await ovpFetch(`/chat/${id}/session`);
    return data;
  },
  /**
   * Send a message to the chat
   * @param {String} id
   * @param {Object} payload
   * @returns {?Object}
   */
  sendMessage: async (id, payload) => {
    const { data } = await ovpFetch(`/chat/${id}/message`, {
      method: 'POST',
      body: JSON.stringify(payload),
      iLikeItRaw: true,
    });
    return data;
  },
  /**
   * Reply to a message in the chat
   * @param {String} id
   * @param {String} messageId
   * @param {Object} payload
   * @returns 
   */
  replyMessage: async (id, messageId, payload) => {
    const { data } = await ovpFetch(`/chat/${id}/message/${messageId}/reply`, {
      method: 'POST',
      body: JSON.stringify(payload),
      iLikeItRaw: true,
    });
    return data;
  },
  /**
   * Delete a message from chat
   * @param {String} id
   * @param {String} messageId
   * @returns {?Object}
   */
  deleteMessage: async (id, messageId, moderator = false) => {
    const { data } = await ovpFetch(`/chat/${id}/message/${messageId}${moderator ? '?moderator=true' : ''}`, {
      method: 'DELETE',
      iLikeItRaw: true,
    });
    return data;
  },
  /**
   * Ban a user from chat
   * @param {String} id
   * @param {String} userId
   * @returns {?Object}
   */
  banUser: async (id, userId) => {
    const { data } = await ovpFetch(`/chat/${id}/session/${userId}/ban`, {
      method: 'POST',
      iLikeItRaw: true,
    });
    return data;
  },
  /**
   * Unban a user from chat
   * @param {String} id
   * @param {String} userId
   * @returns {?Object}
   */
  unbanUser: async (id, userId) => {
    const { data } = await ovpFetch(`/chat/${id}/session/${userId}/unban`, {
      method: 'POST',
      iLikeItRaw: true,
    });
    return data;
  },
};

// eslint-disable-next-line
export { ChatService };
